/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Components */
import FocusableBanner from '../FocusableBanner';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import useOnLeftArrowPress from '../../hooks/useOnLeftArrowPress';
import { useOpenSidebar } from '../../providers/SidebarStateContext';
import { getIsCurableBannerActive } from '../../utils/functions';

/* Hooks */
import useGetUpSellBannerMessage from '../../hooks/useGetUpSellBannerMessage';
import useFetchCurableBanner from '../../hooks/useFetchCurableBanner';

function UpSellBanner({ elementId = '' }) {
  const isCurableBannerActive = getIsCurableBannerActive();
  const dataCurableBanner = useFetchCurableBanner(elementId, isCurableBannerActive);
  const dataUpSellBanner = useGetUpSellBannerMessage(isCurableBannerActive);

  const {
    title,
    subtitle,
    link,
    fixedPhrase,
    icon,
  } = isCurableBannerActive ? dataCurableBanner : dataUpSellBanner;

  const goToSideBar = useOpenSidebar();
  const handleLeftArrowPress = useOnLeftArrowPress(goToSideBar);

  return (
    <FocusableBanner
      onArrowPress={handleLeftArrowPress}
      title={title}
      subtitle={subtitle}
      link={link}
      fixedPhrase={fixedPhrase}
      icon={icon}
    />
  );
}

UpSellBanner.propTypes = {
  elementId: PropTypes.string,
};

export default memo(withInteractiveFocusable()(memo(UpSellBanner)));
